import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import PaletteIcon from "@mui/icons-material/Palette";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import RedeemIcon from "@mui/icons-material/Redeem";
import CelebrationIcon from "@mui/icons-material/Celebration";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import StorefrontIcon from "@mui/icons-material/Storefront";

export const serviceIcons = {
  claw: SportsEsportsIcon,
  photobooth: CameraAltIcon,
  artist: PaletteIcon,
  leaderboard: EmojiEventsIcon,
  giftcards: RedeemIcon,
  events: CelebrationIcon,
  rentals: Inventory2Icon,
  membership: CardMembershipIcon,
  popups: StorefrontIcon,
};
